const ResetPassword = () => {
  return (
    <section className="auth_wrapper">
      <div className="container-fluid p-0">
        <div className="row recovery_box_row">
          <div className="col-lg-6 d-flex">
            <div className="account_recovery_box">
              <h4 className="app_heading">Reset your Password</h4>
              <p className="app_text mt-2 mb-4">
                Now that you're verified, please enter your new password below
              </p>
              <div className="login_form_wrapper">
                <form
                  className="loginBox_form"
                  autoComplete="off"
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <div className="row g-4 mb-0">
                    <div className="col-12">
                      <div className="app_textInputWrapper">
                        <input
                          id="password"
                          className="app_textInput"
                          type="password"
                          placeholder=" "
                          {...register("password", { required: true })}
                        />
                        <label
                          htmlFor="password"
                          className="appInput_Placeholder"
                        >
                          New Password
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="row g-2 mt-1">
                    <div className="col-12">
                      <div className="app_textInputWrapper">
                        <input
                          id="confirmPassword"
                          className="app_textInput"
                          type="password"
                          placeholder=" "
                          {...register("confirmPassword", { required: true })}
                        />
                        <label
                          htmlFor="confirmPassword"
                          className="appInput_Placeholder"
                        >
                          Confirm New Password
                        </label>
                      </div>
                    </div>
                  </div>
                  <button className="app_primary_btn w-100 mt-4">
                    Request a Password Reset
                  </button>
                </form>
              </div>
            </div>
          </div>
          <div className="col-lg-6 d-none d-lg-block">
            <div className="login_image_container"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResetPassword;
